import type { Dayjs } from 'dayjs';
import { getLocalTime, toLocalTime } from 'frontend-utils/utils/dayjs';
import { PA_REF_DAYS_AGO } from 'lumen/utils/constants/pricing-assistant-constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function generateCalendarDaterange(monthDayjs: Dayjs) {
  const dateRangeStart = monthDayjs

    .startOf('month')
    .startOf('week')
    .format('YYYY-MM-DD');
  const dateRangeEnd = monthDayjs

    .endOf('month')
    .endOf('week')
    .startOf('day')
    .format('YYYY-MM-DD');

  return {
    dateRangeStart,
    dateRangeEnd,
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getCalendarMonthDateRanges(month: string, timezone: number) {
  /**
   * 15 was chosen "arbitrarily" to represent the middle of the month.
   */
  const calendarMonth = toLocalTime(`${month}-15`, timezone);

  const { dateRangeStart, dateRangeEnd } =
    generateCalendarDaterange(calendarMonth);

  const compareDate = getLocalTime(timezone)
    .subtract(PA_REF_DAYS_AGO, 'day')
    .format('YYYY-MM-DD');

  return {
    dateRangeStart,
    dateRangeEnd,
    compareDate,
    calendarMonth,
  };
}
